import axios from 'axios';

const updateTeamsSettings = settings => {
  return axios.put('teams/settings', settings);
};

const acceptPolicy = () => axios.put('teams/settings/accept');

export { updateTeamsSettings, acceptPolicy };
